import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HubioTableComponent, HubioTableOptions } from '@hubio/hubio-common-components';
import { brokersConfig } from '../../configs/brokers-table.config';
import { AuditRecord } from '../../models/dashboard.model';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-brokers-table',
  templateUrl: './brokers-table.component.html',
  styleUrls: ['./brokers-table.component.scss']
})
export class BrokersTableComponent implements OnInit {

  @ViewChild('table', { static: true }) public table: HubioTableComponent;
  @Output() public rowClick: EventEmitter<AuditRecord> = new EventEmitter();
  @Input() public data: AuditRecord[];

  public tableOptions: HubioTableOptions
  private tableConfig;

  constructor(
    private dashboardService: DashboardService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  ngAfterViewInit(): void {
    this.getData();
  }

  private initComponent() {
    this.initMetadata();
    this.initTableOptions();
  }

  initMetadata() {
    this.tableConfig = brokersConfig.tableDefinition;
  }

  private initTableOptions() {
    this.tableOptions = {
      columns: this.tableConfig.columns,
      tooltip: this.tableConfig.tooltip,
      paginator: {
        paginate: false
      },
      cache: {
        cache: false
      }
    };
  }

  getData() {
    this.table.setData(this.data, 0);
  }

  handleRowClick(broker: AuditRecord) {
    this.rowClick.emit(broker);
  }

}
